// @flow strict

import * as React from 'react';
import {
  RadioGroup,
  RadioButton as Radio,
} from '@spaced-out/ui-design-system/lib/components/RadioButton';
import {classify} from 'src/utils/classify';

import css from './radio.css';


export {RadioGroup};

export function RadioPair({
  className,
  value,
  label,
}: {
  className?: ?string,
  value: mixed,
  label: React.Node,
  isHorizontal?: boolean,
}): React.Node {
  return (
    <Radio
      // $FlowFixMe[incompatible-type]
      value={value}
      classNames={{wrapper: className ? className : ''}}
    >
      <label className={classify(className)}>
        <span>{label}</span>
      </label>
    </Radio>
  );
}
